import { useOTSTranslation } from '@/i18n/useOTSTranslation';
import { Search } from '@/components/home/Search';
import { PopularSearches } from '@/components/home/PopularSearches';
import { IBackgroundImages, IPopularSearch } from '@/api/home/types';
import { containerClass } from '@/components/ui/container';

// Photo-backed hero band. 570px tall by default with a primary-blue
// fallback bg-color in case the SSR photo URL doesn't resolve. A
// semi-transparent primary overlay (the .background sibling) tints the
// photo for legibility behind the white headline copy.
const photoClass = [
  'relative min-h-[570px] text-center bg-primary bg-cover bg-center',
  'max-md:min-h-[500px]',
  '[&>.home-hero-container]:relative [&>.home-hero-container]:z-[11] [&>.home-hero-container]:h-[570px]',
  'max-md:[&>.home-hero-container]:h-[500px]',
].join(' ');

const overlayClass = 'absolute inset-0 bg-primary opacity-10';

// Legacy Bootstrap `.container` is gone, so the centered width ladder has
// to come from ui/container's drop-in `containerClass` — bare Tailwind
// `container` only sets max-widths and leaves the box left-aligned.
const heroContainerClass = [
  'home-hero-container',
  containerClass,
  'pt-[60px]',
  'max-lg:px-2.5 max-lg:pt-20',
].join(' ');

const titleClass = [
  'block font-bold text-white text-[2.390625rem] leading-[3.71875rem] m-0',
  'max-md:text-[1.7rem] max-md:leading-[2.55rem] max-md:mb-3',
].join(' ');

const subtitleClass = [
  'block font-normal text-white text-[1.0625rem] leading-[140%] mb-6',
  'max-md:text-xs max-md:mb-5',
].join(' ');

export const HomeHero = ({
  backgroundImage,
  popularSearch,
  searchQuery,
  clearSearchQuery,
  loading,
}: {
  backgroundImage: IBackgroundImages,
  popularSearch: IPopularSearch,
  searchQuery: string | string[] | undefined,
  clearSearchQuery?: () => void,
  loading?: boolean,
}) => {
  const { t } = useOTSTranslation('common');

  return (
    <header
      className={photoClass}
      style={!loading ? { backgroundImage: `url("${backgroundImage.image}")` } : {}}
    >
      <div className={overlayClass} />
      <div className={heroContainerClass}>
        <span className={titleClass}>{t('homePage.heroTitle')}</span>
        <span className={subtitleClass}>{t('homePage.heroSubtitle')}</span>
        <Search searchQuery={searchQuery} clearSearchQuery={clearSearchQuery} />
        <PopularSearches popularSearch={popularSearch} />
      </div>
    </header>
  );
};
